export enum SsoProviderType {
  AZURE_AD = "azure_ad",
}
